import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { faWindowClose, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AutoGrowTextarea } from "../../../components/AutoGrowTextarea";

export const AddEditReceivedPaymentItems = ({
    values,
    errors,
    touched,
    handleBlur,
    handleFormChangeItems,
    removeFields,
    addFields,
}) => {
    return (
        <>
            <Row className="mb-2">
                <Col md={1}>S/N</Col>
                <Col md={2}>Item</Col>
                <Col md={3}>Description</Col>
                <Col md={1}>Quantity</Col>
                <Col md={2}>Rate (S$)</Col>
                <Col md={2}>Amount (S$)</Col>
            </Row>
            <hr style={{ border: "1px solid" }} />
            {values.received_payment_items.length ? (
                values.received_payment_items.map((input, index) => {
                    return (
                        <Row key={index}>
                            <Col md={1}>{index + 1}</Col>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="text"
                                        name="item"
                                        id="item"
                                        value={
                                            values.received_payment_items[index]
                                                ?.item
                                        }
                                        isInvalid={Boolean(
                                            errors.received_payment_items &&
                                                touched.received_payment_items &&
                                                errors.received_payment_items[
                                                    index
                                                ]?.item &&
                                                touched.received_payment_items[
                                                    index
                                                ]?.item
                                        )}
                                        onChange={(event) => {
                                            handleFormChangeItems(index, event);
                                        }}
                                    />
                                    {errors.received_payment_items &&
                                        errors.received_payment_items[index]
                                            ?.item && (
                                            <Form.Control.Feedback type="invalid">
                                                Item is a required field
                                            </Form.Control.Feedback>
                                        )}
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <AutoGrowTextarea
                                        name="description"
                                        id="description"
                                        fieldValue={
                                            values.received_payment_items[index]
                                                ?.description
                                        }
                                        handleBlur={handleBlur}
                                        index={index}
                                        handleFormChangeItems={
                                            handleFormChangeItems
                                        }
                                        isInvalid={Boolean(
                                            errors.received_payment_items &&
                                                touched.received_payment_items &&
                                                errors.received_payment_items[
                                                    index
                                                ]?.description &&
                                                touched.received_payment_items[
                                                    index
                                                ]?.description
                                        )}
                                    />
                                    {errors.received_payment_items &&
                                        errors.received_payment_items[index]
                                            ?.description && (
                                            <Form.Control.Feedback type="invalid">
                                                Description is a required field
                                            </Form.Control.Feedback>
                                        )}
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="number"
                                        name="quantity"
                                        id="quantity"
                                        min="0"
                                        value={
                                            values.received_payment_items[index]
                                                ?.quantity
                                        }
                                        isInvalid={Boolean(
                                            errors.received_payment_items &&
                                                touched.received_payment_items &&
                                                errors.received_payment_items[
                                                    index
                                                ]?.quantity &&
                                                touched.received_payment_items[
                                                    index
                                                ]?.quantity
                                        )}
                                        onChange={(event) => {
                                            handleFormChangeItems(index, event);
                                        }}
                                    />
                                    {errors.received_payment_items &&
                                        errors.received_payment_items[index]
                                            ?.quantity && (
                                            <Form.Control.Feedback type="invalid">
                                                Quantity is a required field
                                            </Form.Control.Feedback>
                                        )}
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="number"
                                        name="rate"
                                        id="rate"
                                        min="0"
                                        value={
                                            values.received_payment_items[index]
                                                ?.rate
                                        }
                                        isInvalid={Boolean(
                                            errors.received_payment_items &&
                                                touched.received_payment_items &&
                                                errors.received_payment_items[
                                                    index
                                                ]?.rate &&
                                                touched.received_payment_items[
                                                    index
                                                ]?.rate
                                        )}
                                        onChange={(event) => {
                                            handleFormChangeItems(index, event);
                                        }}
                                    />
                                    {errors.received_payment_items &&
                                        errors.received_payment_items[index]
                                            ?.rate && (
                                            <Form.Control.Feedback type="invalid">
                                                Rate is a required field
                                            </Form.Control.Feedback>
                                        )}
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                {Number(
                                    values.received_payment_items[index]?.amount
                                ).toFixed(2)}
                            </Col>
                            <Col md={1}>
                                <Button
                                    variant="primary"
                                    onClick={() => removeFields(index)}
                                    className=""
                                >
                                    <FontAwesomeIcon icon={faWindowClose} />
                                </Button>
                            </Col>
                        </Row>
                    );
                })
            ) : (
                <Row index="1234">
                    <Col md={12} className="text-center">
                        Add a new item to create a quotation
                    </Col>
                </Row>
            )}
            <Button variant="secondary" onClick={addFields} className="mt-3">
                <FontAwesomeIcon icon={faPlusSquare} /> Add new item
            </Button>
            <hr />
            <Row className="mt-3">
                <Col md={4}></Col>
                <Col md={4}></Col>
                <Col md={4}>
                    {/* WIP - Currency */}
                    {/* <Row className="mt-3">
            <Col md={6}>
              <Form.Select name="user" id="user">
                <option value="sgd">SGD</option>
                <option value="usd">USD</option>
              </Form.Select>
            </Col>
          </Row>
          <hr /> */}
                    <Row className="mt-3">
                        <Col md={6}>
                            <h4>Subtotal</h4>
                        </Col>
                        <Col md={6}>
                            <h4 className="text-end">
                                S${Number(values.subtotal).toFixed(2)}
                            </h4>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={6}>
                            <h4>GST</h4>
                        </Col>
                        <Col md={6}>
                            <h4 className="text-end">7%</h4>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={6}>
                            <h4>Total (SGD)</h4>
                        </Col>
                        <Col md={6}>
                            <h4 className="text-end">
                                S${Number(values.total).toFixed(2)}
                            </h4>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};
